"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/portal_common.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalAddresses = exports.PortalAddress = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.shipping.v1.PortalAddress
 */
class PortalAddress extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string address_id = 1;
         */
        this.addressId = "";
        /**
         * @generated from field: string postal_code = 2;
         */
        this.postalCode = "";
        /**
         * @generated from field: string prefecture = 3;
         */
        this.prefecture = "";
        /**
         * @generated from field: string city = 4;
         */
        this.city = "";
        /**
         * @generated from field: string street_address = 5;
         */
        this.streetAddress = "";
        /**
         * @generated from field: string residence = 6;
         */
        this.residence = "";
        /**
         * @generated from field: string name = 7;
         */
        this.name = "";
        /**
         * @generated from field: string phone_number = 8;
         */
        this.phoneNumber = "";
        /**
         * @generated from field: bool is_default = 9;
         */
        this.isDefault = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAddress().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAddress().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAddress().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAddress, a, b);
    }
}
exports.PortalAddress = PortalAddress;
PortalAddress.runtime = protobuf_1.proto3;
PortalAddress.typeName = "spwn.shipping.v1.PortalAddress";
PortalAddress.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "prefecture", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "street_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "residence", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.shipping.v1.PortalAddresses
 */
class PortalAddresses extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.shipping.v1.PortalAddress other_addresses = 2;
         */
        this.otherAddresses = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAddresses().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAddresses().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAddresses().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalAddresses, a, b);
    }
}
exports.PortalAddresses = PortalAddresses;
PortalAddresses.runtime = protobuf_1.proto3;
PortalAddresses.typeName = "spwn.shipping.v1.PortalAddresses";
PortalAddresses.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "default_address", kind: "message", T: PortalAddress },
    { no: 2, name: "other_addresses", kind: "message", T: PortalAddress, repeated: true },
]);
//# sourceMappingURL=portal_common_pb.js.map